<template>
    <div class="back-button" @click="$router.go(-1)">
        &#8592;
    </div>
</template>

<style scoped>
    .back-button {
        display: inline-block;
        width: 30px;
        height: 30px;
        border-radius: 30px;
        background: #EAF1FA;
        color: #6aa1f5;
        text-align: center;
        cursor: pointer;
        margin-right: 10px;
    }
</style>

<script>
export default {
    name: 'Backbutton'
}
</script>